export const selectAuthState = (state) => state.auth;
export const selectToken = (state) => state.auth?.token;
export const selectUser = (state) => state.auth?.user;
export const selectIsLoggedIn = (state) => state.auth?.isLoggedIn || false;

export const selectOtpSession = (state) => state.auth?.otpSession;
export const selectOtpPhone = (state) => state.auth?.otpPhone;

export const selectIsOtpLoading = (state) => state.auth?.loading?.otp || false;
export const selectIsLoginLoading = (state) => state.auth?.loading?.login || false;
export const selectIsSignupLoading = (state) => state.auth?.loading?.signup || false;
export const selectIsUserLoading = (state) => state.auth?.loading?.user || false;
export const selectIsAnyAuthLoading = (state) => {
    const loading = state.auth?.loading;
    return loading?.otp || loading?.login || loading?.signup || loading?.user || false;
};

export const selectOtpError = (state) => state.auth?.error?.otp || null;
export const selectLoginError = (state) => state.auth?.error?.login || null;
export const selectSignupError = (state) => state.auth?.error?.signup || null;
export const selectUserError = (state) => state.auth?.error?.user || null;

export const selectUserDisplayName = (state) => {
    const user = state.auth?.user;
    return user?.display_name || user?.first_name || user?.billing?.first_name || null;
};

export const selectUserEmail = (state) => state.auth?.user?.email || state.auth?.user?.billing?.email || null;
export const selectUserPhone = (state) => state.auth?.user?.billing?.phone || null;

export const authSelectors = {
    selectAuthState,
    selectToken,
    selectUser,
    selectIsLoggedIn,
    selectOtpSession,
    selectOtpPhone,
    selectIsOtpLoading,
    selectIsLoginLoading,
    selectIsSignupLoading,
    selectIsUserLoading,
    selectIsAnyAuthLoading,
    selectOtpError,
    selectLoginError,
    selectSignupError,
    selectUserError,
    selectUserDisplayName,
    selectUserEmail,
    selectUserPhone,
};

export default authSelectors;
